// 검색결과 리스트 쿼리의 '계약' — 서버 프리페치(search/result/page.tsx)와
// 클라 컴포넌트(SearchResultList)가 같은 파라미터 해석·같은 queryKey 를 쓰도록 한곳에 모은다.
// 어긋나면 장애 대신 'SSR 효과 소멸 + 이중 fetch'로 조용히 새기 때문에 테스트로 잠근다.

export const parseSearchListParams = (get: (key: string) => string | null) => ({
  keyword: get("query") || "",
  treatmentIds: get("treatment")?.split(",").map(Number) || [],
  rawRegionIds: get("region")?.split(",").map(Number).filter(Boolean) ?? [],
})

export const searchListQueryKey = (keyword: string, regionIds: number[], treatmentIds: number[]) =>
  ["searchList", keyword, regionIds.join(","), treatmentIds.join(",")] as const
